import NewsLetter from '../../utils/newsletter';

new NewsLetter('#newsletterForm');

